import axios from "axios";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;


const requestAuditService = {
  getAuditRequestByGpid: async (data) => {
    try {
      const response = await axios.post(
        `${API_ENDPOINT}auditRequest/getAuditRequest`,
        data,
      );

      return response;
    } catch (error) {
      throw error;
    }
  },
  getAuditRequestByRequestNumber: async (data) => {
    try {
      const response = await axios.post(
        `${API_ENDPOINT}auditRequest/viewRequest`,
        data,
      );

      return response;
    } catch (error) {
      throw error;
    }
  },
  getEntraAuditRequestByRequestNumber: async (data) => {
    try {
      const response = await axios.post(
        `${API_ENDPOINT}entra/searchRequest`,
        data,
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  entraCancelRequest: async (data) => {
    try {
      const response = await axios.post(
        `${API_ENDPOINT}entra/cancelRequest`,
        data,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  mypamCancelOrRemindRequest: async (data, cancelOrRemind, requestNumber) => {
    try {
      const response = await axios.post(
        `${API_ENDPOINT}pam/safeManagement/${requestNumber}/${cancelOrRemind === 'cancel' ? 'cancel' : 'remind'}`,
        data,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  entraSendFollowUp: async (data) => {
    try {
      const response = await axios.post(
        `${API_ENDPOINT}entra/sendReminder`,
        data,
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  },
  
  sendFollowUp: async (data) => {
    try {
      const response = await axios.post(
        `${API_ENDPOINT}auditRequest/sendFollowUp`,
        data,
      );

      return response;
    } catch (error) {
      throw error;
    }
  },

  cancelRequest: async (data) => {
    try {
      const response = await axios.post(
        `${API_ENDPOINT}auditRequest/getCancelRequest`,
        data,
      );
      return response;
    } catch (error) {
      throw error;
    }
  },
  ssoCancelRequest: async (requestNumber) => {
    try {
      const response = await axios.post(
        `${API_ENDPOINT}auditRequest/${requestNumber}/cancel`,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  ssoSendReminder: async (requestNumber) => {
    try {
      const response = await axios.post(
        `${API_ENDPOINT}auditRequest/${requestNumber}/remind`,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getSSOAttachment: async (requestNumber, type) => {
    try {
      const response = await axios.get(
        `${API_ENDPOINT}sso/attachments/${requestNumber}/${type}`,
        { responseType: 'blob' }
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
}

export default requestAuditService;
